import { Component, Host, Prop, h } from '@stencil/core';

@Component({
  tag: 'expect-message',
  styleUrl: 'expect-message.css',
})
export class ExpectMessage {
  @Prop() shouldDisplayExpectDealership: boolean = false;

  render() {
    if (!this.shouldDisplayExpectDealership) {
      return null;
    }
    return (
      <Host>
        <div class="@container h-full">
          <div class="bg-clrs-white rounded-lg shadow-drop h-full" data-testId="expect-dealership">
            <div class="flex flex-col text-sm text-black font-open-sans py-4 pr-4 @xs:px-6 @md:px-12">
              <h3 class="mb-5 font-extrabold text-lg font-montserrat">What to Expect at the Dealership</h3>
              <span class="mb-2 text-sm">The dealer will inspect your vehicle using the same questions you used at home.</span>
              <span class="mb-2 text-sm">
                You may not have caught everything when assessing your vehicle. That’s OK. After their inspection, the dealer will show you a side-by-side comparison so you can
                agree on what’s fair.
              </span>
            </div>
          </div>
        </div>
      </Host>
    );
  }
}
